import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Column } from '@xingternal/xing-grid';

import { useTrackSubmitConfirmationPageview } from '../../hooks';
import { SubmitConfirmationHeader } from './submit-confirmation-header';
import { useSubmitConfirmationCopies } from './use-submit-confirmation-copies';

import * as S from './submit-confirmation.styles';

export const SubmitConfirmationLi: React.VFC<{ onClose: () => void }> = ({ onClose }) => {
  const copies = useSubmitConfirmationCopies();

  useTrackSubmitConfirmationPageview();

  return (
    <Column size={10} sizeWide={8} offsetWide={2} offset={1}>
      <S.ContentWrapper>
        <SubmitConfirmationHeader copyKey={copies.header} />
        <S.Body size="medium">
          <FormattedMessage id={copies.body} />
        </S.Body>
        <S.CtaButton variant="primary" size="medium" onClick={onClose}>
          <FormattedMessage id={copies.cta} />
        </S.CtaButton>
      </S.ContentWrapper>
    </Column>
  );
};
